"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blueCardPlaceholders = exports.whiteCardPlaceholders = void 0;
exports.whiteCardPlaceholders = {
    buttonText: 'Get pre-approved',
    modalOpener: 'See sample loan terms',
};
exports.blueCardPlaceholders = {
    buttonText: 'Get your personalized rate',
    informationText: "Mortgage rates aren't one size fits all. We can give you an estimate based on your unique details.",
    defaultImage: 'https://delivery.digitalassets.zillowgroup.com/api/public/content/SZ_STUDIO_B2CPA_LA_Edeani_2024_Colonial_Ext_Porch_0500_rgb_768x360?v=d326909e',
};
